import React, { useEffect, useRef } from 'react';
const BASE_CONFIG = {
  allow_symbol_change: true,
  calendar: false,
  save_image: true,
  interval: '15',
  locale: 'en',
  style: '1',
  symbol: 'OANDA:XAUUSD',
  theme: 'dark',
  timezone: 'America/New_York',
  backgroundColor: '#0F0F0F',
  gridColor: 'rgba(242, 242, 242, 0.2)',
  compareSymbols: [],
  studies: ['STD;Trading%1Sessions'],
  autosize: true
};
const DESKTOP_CONFIG = {
  ...BASE_CONFIG,
  details: true,
  hide_side_toolbar: false,
  hide_top_toolbar: false,
  hide_legend: false,
  hide_volume: false,
  hotlist: true,
  withdateranges: true,
  watchlist: ['OANDA:XAUUSD', 'BINANCE:BTCUSDT', 'FOREXCOM:EURUSD', 'CAPITALCOM:NAS100', 'CAPITALCOM:SPX500']
};

/* On phones the side panels and watchlist eat the whole canvas,
   so the chart itself gets the full width instead. */
const MOBILE_CONFIG = {
  ...BASE_CONFIG,
  details: false,
  hide_side_toolbar: false,
  hide_top_toolbar: false,
  hide_legend: false,
  hide_volume: true,
  hotlist: false,
  withdateranges: false,
  watchlist: []
};
interface TradingViewChartProps {
  /** Fill the parent container instead of using the inline hero sizing. */
  fill?: boolean;
}
export function TradingViewChart({
  fill = false
}: TradingViewChartProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches;
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = JSON.stringify(isMobile ? MOBILE_CONFIG : DESKTOP_CONFIG);
    container.appendChild(script);
    return () => {
      container.innerHTML = '';
    };
  }, []);
  return <div className={fill ? 'h-full w-full' : 'mx-auto h-[70vh] max-h-[610px] min-h-[420px] w-full max-w-[980px] md:h-[610px] md:max-h-none'} data-id="element-113" data-mp="22x43fsvbu65h">
      <div className="tradingview-widget-container h-full w-full" ref={containerRef} data-id="element-114" data-mp="3pfaws699yoe">
        <div className="tradingview-widget-container__widget h-full w-full" data-id="element-115" data-mp="3uxjebreuixhx" />
      </div>
    </div>;
}